import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, PrizeTypesData } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: {
      totalCount: 0
    },
  },
};

const PrizeTypesSlice = createSlice({
  name: 'prizeTypes',
  initialState,
  reducers: {
    setPrizeTypesData(state: initState, action: PayloadAction<{ list: PrizeTypesData }>) {
      state.list = action.payload.list;
    },
  },
});

export const { setPrizeTypesData } = PrizeTypesSlice.actions;

export default PrizeTypesSlice.reducer;
